<!-- 开发设置 --  数据迁移 -- 执行SQL和执行文件 -->
<template>
  <basic-container>
    <div>
      <h3 style="text-align:center">{{$route.query.title}}</h3>
      <el-form label-width="100px">
        <el-backtop tranget=".el-form .page_scroll" :visibility-height="500"> <i class="el-icon-caret-top"></i> </el-backtop>
        <el-form-item label="是否查询：">
          <!-- <el-switch
            v-model="obj.queryType"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="2"
            active-text="是"
            inactive-text="否">
          </el-switch> -->
          <el-button size="mini" type="primary" @click.stop="zxSeach">执行查询</el-button>
          <el-button size="mini" type="primary" @click.stop="zxUpdate">执行更新</el-button>
        </el-form-item>
        <el-form-item label="输入语句：" v-if="textarea">
          <el-input type="textarea" v-model="obj.sqltext" :autosize="{minRows:5}"></el-input>
        </el-form-item>
        <el-form-item class="page_scroll" label="查询数据：" v-if="($route.query.type == 'SQL' || $route.query.type == 'hczx') && obj.jsonIsShow">
          <json-viewer :copyable="true" boxed :value="jsonType" :expand-depth="1" :expanded="false"></json-viewer>
        </el-form-item>
        <el-form-item label="上传文件：" v-if="$route.query.type == 'File'">
          <el-upload ref="upload" action="1" :on-remove="handleRemove" :auto-upload="false" :on-change="uploadChange" :file-list="sqlList" accept=".txt,.sql">
            <el-button type="primary" icon="el-icon-upload" size="mini">选择附件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- <el-col style="text-align:center">
        <el-button size="mini" type="primary" @click.stop="saveClick">确 定</el-button>
      </el-col> -->
    </div>
  </basic-container>
</template>

<script>
import { executeSqls, executeSqlFiles, executeLocal } from '@/api/system/dataSy';
import JsonViewer from 'vue-json-viewer';
import 'vue-json-viewer/style.css';
import { updateShow } from "@/api/table/table";
import crypto from "@/util/crypto";
export default {
  components: {
    JsonViewer
  },
  props:["option"],
  data() {
    return {
      sqlList:[],
      obj:{
        queryType:1,
        sqltext:"",
        password:"",
        jsonIsShow:false,
      },
      jsonType:{},
      headerFixed: false,
      textarea:false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 改变附件
    uploadChange(file,fileList){
      let existFile=fileList.slice(0,fileList.length-1).find(f=>f.name===file.name)
      if(existFile){
        this.$message.error("当前文件已存在!");
        fileList.pop();
      }
      this.sqlList=fileList;
    },
    // 删除附件
    handleRemove(file,fileList){
      this.sqlList = fileList;
    },
    // 点击确认
    async saveClick(){
      if(this.$route.query.type === "SQL" || this.$route.query.type === "hczx"){
        let obj = {sql:this.obj.sqltext,queryType:this.obj.queryType,number: this.$route.query.number,password:this.$route.query.password},res;
        // blade-develop/usual/api/executeRedisString
        if(this.$route.query.type == "SQL"){
          console.log(crypto);
          obj.sql=crypto.encryptAES(obj.sql,crypto.aesKey); // aes加密
          res = await executeSqls(this.$qs.stringify({...obj,id:this.$route.query.rowID}))
        }else{res = await executeLocal(this.$qs.stringify(obj))}
        console.log(res);
        if(this.obj.queryType == 1){
          this.jsonType = {...res.data.data};
          this.$set(this.obj,"jsonIsShow",true);
          this.$message.success("查询成功!");
        }else{
          this.jsonType = {};
          this.$set(this.obj,"jsonIsShow",false);
          this.$message.success("操作成功!");
          // this.$refs.table.$refs.child.onLoad();
        }
        // this.$refs.table.$refs.child.onLoad();
      }else{
        if(this.sqlList.length===0){
          this.$message.error("必须上传一个文件!");
          return;
        }
        let fileData = new FormData();
        fileData.append("sql",this.sqlList[0].raw);
        fileData.append("queryType",this.obj.queryType);
        fileData.append("number",this.$route.query.number);
        fileData.append("password",this.$route.query.password);
        executeSqlFiles(fileData).then(res => {
          console.log(res);
        })
      }
    },
    // 点击执行查询
    zxSeach(){
      this.obj.queryType = 1;
      this.saveClick();
    },
    // 点击执行更新
    zxUpdate(){
      this.obj.queryType = 2;
      this.saveClick();
    }
  },
  mounted() {
  },
  destroyed() {
  },
  created() {},
  activated() {
    if(this.$route.query.type == 'SQL' || this.$route.query.type == 'hczx'){
      this.textarea = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.page_scroll{
  height: 500px;
  overflow-x: hidden;
}
</style>
